<template>
  <div class="receipt-page">

    <!-- PRINT BUTTON -->
    <div class="print-toolbar no-display">
      <v-btn tile outlined color="warning" @click="printReceipt">
        <v-icon left>mdi-printer</v-icon>
        PRINT
      </v-btn>
    </div>
    <div v-if="receiptData" id="des-receipt-print-area" class="receipt-container">
      <div class="header-logo">
        <img v-if="schoolLogo" :src="schoolLogo" alt="School Logo" />
        <div v-else class="logo-placeholder">
          School Logo
        </div>
      </div>

      <div class="school-info-center">
        <div v-if="trustName" class="trust-name">
          {{ trustName }}
        </div>

        <div v-if="schoolName" class="school-name">
          {{ schoolName }}
        </div>

        <div v-if="schoolAddress" class="school-address">
          {{ schoolAddress }}
        </div>

      </div>

      <div class="receipt-title-wrapper">

        <h3 class="receipt-title">
          Activity Fees Receipt
        </h3>

      </div>

      <div class="info-grid">

        <!-- ROW 1 -->
        <div class="info-row">

          <div class="info-col text-left">
            <span class="label">
              Receipt No :
            </span>

            <span class="value">
              {{ receiptNumber }}
            </span>
          </div>


          <div class="info-col text-center">
            <span class="label">
              Date :
            </span>

            <span class="value">
              {{ registrationDate }}
            </span>
          </div>


          <div class="info-col text-right">
            <span class="label">
              Academic Year :
            </span>

            <span class="value">
              {{ academicYear }}
            </span>
          </div>

        </div>


        <!-- ROW 2 -->
        <div class="info-row">

          <div class="info-col text-left">
            <span class="label">
              Activity :
            </span>

            <span class="value">
              {{ activityName }}
            </span>
          </div>


          <div class="info-col text-center">
            <span class="label">
              Category :
            </span>

            <span class="value">
              {{ activityCategory }}
            </span>
          </div>


          <div class="info-col text-right">
            <span class="label">
              Payment Mode :
            </span>

            <span class="value">
              {{ paymentMode }}
            </span>
          </div>

        </div>

        <div class="info-row">

          <div class="info-col text-left">
            <span class="label">
              Participant Name :
            </span>

            <span class="value">
              {{ aname }}
            </span>
          </div>


          <div class="info-col text-center">
            <span class="label">
              Participant Type :
            </span>

            <span class="value">
              {{ participantType }}
            </span>
          </div>


          <div class="info-col text-right">
            <span class="label">
              Affiliation :
            </span>

            <span class="value">
              {{ affiliationType }}
            </span>
          </div>

        </div>

      </div>

      <div class="table-wrapper">

        <table class="bordered-table particulars-table">

          <thead>

            <tr>
              <th>Sr. No</th>
              <th>Particulars</th>
              <th>Amount</th>
            </tr>

          </thead>


          <tbody>
            <tr v-for="(item, index) in feeDetails" :key="index">

              <td>
                {{ index + 1 }}
              </td>

              <td class="particular-name">
                {{
                  item.component ||
                  item.fee_head ||
                  item.name ||
                  item.title ||
                  "Activity Fees"
                }}
              </td>

              <td>
                {{ formatAmount(item.amount) }}
              </td>

            </tr>


            <!-- FALLBACK WHEN NO FEE DETAILS -->
            <tr v-if="feeDetails.length === 0">

              <td>
                1
              </td>

              <td class="particular-name">
                Activity Fees
              </td>

              <td>
                {{ formatAmount(totalAmount) }}
              </td>

            </tr>

            <tr class="total-row">

              <td colspan="2" class="total-label-cell">
                <span class="total-label">
                  Total Amount
                </span>
              </td>


              <td class="total-amount-cell">

                <strong>
                  {{ formatAmount(totalAmount) }}
                </strong>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

      <div class="acknowledgment-text">

        Received with thanks Rs.
        <strong>
          {{ formatAmount(totalAmount) }}
        </strong>

        from

        <strong>
          {{ aname }}
        </strong>

        against activity :

        <strong>
          "{{ activityName }}"
        </strong>

      </div>

      <div class="table-wrapper">

        <table class="bordered-table transaction-table">

          <thead>

            <tr>
              <th>Date</th>
              <th>Transaction No</th>
              <th>Payment Mode</th>
              <th>Amount</th>
            </tr>

          </thead>


          <tbody>

            <tr>

              <td>
                {{ registrationDate }}
              </td>

              <td>
                {{ transactionNumber }}
              </td>

              <td>
                {{ paymentMode }}
              </td>

              <td>
                {{ formatAmount(totalAmount) }}
              </td>

            </tr>

          </tbody>

        </table>

      </div>

      <div class="footer-signature">
        Authorized Signatory
      </div>

    </div>
    <div v-else class="loading-container">

      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>

      <div class="loading-text">
        Loading receipt data...
      </div>

    </div>

  </div>
</template>


<script>
export default {

  name: "ActivityReceipt",


  data: () => ({
    receiptData: null,
    activitydata: null,
    receipt_no: null,
    org_basic_data: {}

  }),


  computed: {

    aname() {

      if (
        this.receiptData &&
        this.receiptData.name
      ) {

        var name =
          String(this.receiptData.name);

        return name
          .split(" ")
          .filter(function (word) {
            return word !== "";
          })
          .map(function (word) {

            return (
              word.charAt(0).toUpperCase() +
              word.slice(1).toLowerCase()
            );

          })
          .join(" ");

      }

      return "-";
    },

    receiptNumber() {

      if (
        this.receiptData &&
        this.receiptData.receipt_no
      ) {

        return this.receiptData.receipt_no;

      }

      if (this.receipt_no) {

        return this.receipt_no;

      }

      return "-";
    },

    registrationDate() {

      if (
        this.receiptData &&
        this.receiptData.registration_date
      ) {

        return this.receiptData.registration_date;

      }

      return "-";
    },
    academicYear() {

      if (
        this.activitydata &&
        this.activitydata.ay
      ) {

        return this.activitydata.ay;

      }

      if (
        this.activitydata &&
        this.activitydata.academic_year
      ) {

        return this.activitydata.academic_year;

      }

      if (
        this.receiptData &&
        this.receiptData.ay
      ) {

        return this.receiptData.ay;

      }

      return "-";
    },

    activityName() {

      if (
        this.activitydata &&
        this.activitydata.title
      ) {

        return this.activitydata.title;

      }

      if (
        this.activitydata &&
        this.activitydata.activity
      ) {

        return this.activitydata.activity;

      }

      if (
        this.receiptData &&
        this.receiptData.title
      ) {

        return this.receiptData.title;

      }

      if (
        this.receiptData &&
        this.receiptData.activity
      ) {

        return this.receiptData.activity;

      }

      return "-";
    },

    activityCategory() {

      if (
        this.activitydata &&
        this.activitydata.category
      ) {

        return this.activitydata.category;

      }

      if (
        this.receiptData &&
        this.receiptData.category
      ) {

        return this.receiptData.category;

      }

      return "-";
    },

    paymentMode() {

      if (
        this.receiptData &&
        this.receiptData.paymentmode
      ) {

        return this.receiptData.paymentmode;

      }

      if (
        this.receiptData &&
        this.receiptData.payment_mode
      ) {

        return this.receiptData.payment_mode;

      }

      return "-";
    },

    participantType() {

      if (
        this.receiptData &&
        this.receiptData.participant_type
      ) {

        return this.receiptData.participant_type;

      }

      return "-";
    },
    affiliationType() {

      if (
        this.receiptData &&
        this.receiptData.affiliation_type
      ) {

        return this.receiptData.affiliation_type;

      }

      return "-";
    },
    transactionNumber() {

      if (
        this.receiptData &&
        this.receiptData.transaction_no
      ) {

        return this.receiptData.transaction_no;

      }

      if (
        this.receiptData &&
        this.receiptData.transaction_number
      ) {

        return this.receiptData.transaction_number;

      }

      if (
        this.receiptData &&
        this.receiptData.receipt_no
      ) {

        return this.receiptData.receipt_no;

      }

      return "-";
    },
    totalAmount() {

      if (
        this.receiptData &&
        this.receiptData.total_fees_amount !== null &&
        this.receiptData.total_fees_amount !== undefined &&
        this.receiptData.total_fees_amount !== ""
      ) {

        return Number(
          this.receiptData.total_fees_amount
        );

      }
      if (
        this.receiptData &&
        this.receiptData.fees_amount !== null &&
        this.receiptData.fees_amount !== undefined &&
        this.receiptData.fees_amount !== ""
      ) {

        return Number(
          this.receiptData.fees_amount
        );

      }
      if (
        this.feeDetails &&
        this.feeDetails.length > 0
      ) {

        var total = 0;

        this.feeDetails.forEach(function (item) {

          total += Number(
            item.amount || 0
          );

        });

        return total;
      }


      return 0;
    },

    feeDetails() {

      if (
        this.receiptData &&
        Array.isArray(
          this.receiptData.student_receipt_details
        )
      ) {

        return this.receiptData.student_receipt_details;

      }


      if (
        this.receiptData &&
        Array.isArray(
          this.receiptData.fee_details
        )
      ) {

        return this.receiptData.fee_details;

      }


      if (
        this.receiptData &&
        Array.isArray(
          this.receiptData.fees_structure_list
        )
      ) {

        return this.receiptData.fees_structure_list;

      }


      return [];
    },
    schoolLogo() {

      if (
        this.org_basic_data &&
        this.org_basic_data.school_logo
      ) {

        return this.org_basic_data.school_logo;

      }

      if (
        this.org_basic_data &&
        this.org_basic_data.trust_logo
      ) {

        return this.org_basic_data.trust_logo;

      }

      return "";
    },

    trustName() {

      if (
        this.org_basic_data &&
        this.org_basic_data.trust_name
      ) {

        return this.org_basic_data.trust_name;

      }

      return "";
    },

    schoolName() {

      if (
        this.org_basic_data &&
        this.org_basic_data.school_name
      ) {

        return this.org_basic_data.school_name;

      }

      return "";
    },

    schoolAddress() {

      if (
        this.org_basic_data &&
        this.org_basic_data.address
      ) {

        return this.org_basic_data.address;

      }

      return "";
    }

  },


  mounted() {

    this.receipt_no =
      localStorage.getItem("Receipt-No");
    var receiptDetails =
      localStorage.getItem("receiptdetails");
    var activity =
      localStorage.getItem("Activity");
    var organization =
      localStorage.getItem("org_basic_data");

    console.log(
      "Receipt-No:",
      this.receipt_no
    );

    console.log(
      "Raw receiptdetails:",
      receiptDetails
    );

    console.log(
      "Raw Activity:",
      activity
    );

    console.log(
      "Raw org_basic_data:",
      organization
    );
    if (receiptDetails) {

      try {

        this.receiptData =
          JSON.parse(receiptDetails);

      } catch (error) {

        console.error(
          "Error parsing receiptdetails:",
          error
        );

        this.receiptData = null;

      }

    }

    if (activity) {

      try {

        this.activitydata =
          JSON.parse(activity);

      } catch (error) {

        console.error(
          "Error parsing Activity:",
          error
        );

        this.activitydata = null;

      }

    }
    if (organization) {

      try {

        this.org_basic_data =
          JSON.parse(organization);

      } catch (error) {

        console.error(
          "Error parsing org_basic_data:",
          error
        );

        this.org_basic_data = {};

      }

    }

    console.log(
      "Final receiptData:",
      this.receiptData
    );

    console.log(
      "Final activitydata:",
      this.activitydata
    );

    console.log(
      "Participant Name:",
      this.aname
    );

    console.log(
      "Activity Name:",
      this.activityName
    );

    console.log(
      "Category:",
      this.activityCategory
    );

    console.log(
      "Academic Year:",
      this.academicYear
    );

    console.log(
      "Total Amount:",
      this.totalAmount
    );

    console.log(
      "Fee Details:",
      this.feeDetails
    );

  },


  methods: {

    formatAmount(value) {

      if (
        value === null ||
        value === undefined ||
        value === ""
      ) {

        return "0";

      }


      var number =
        Number(value);


      if (isNaN(number)) {

        return "0";

      }


      return number.toLocaleString(
        "en-IN",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }
      );
    },
    printReceipt() {

      var printArea =
        document.getElementById(
          "des-receipt-print-area"
        );


      if (!printArea) {

        console.error(
          "Receipt print area not found"
        );

        return;

      }
      


      var printContent =
        printArea.innerHTML;


      var originalContent =
        document.body.innerHTML;


      document.body.innerHTML =
        printContent;


      window.print();


      document.body.innerHTML =
        originalContent;


      window.location.reload();

    }

  }

};

</script>


<style scoped>

.receipt-page {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  padding: 20px 0;
}

.print-toolbar {
  width: 900px;
  max-width: 95%;
  margin: 0 auto 15px auto;
  text-align: right;
}


.receipt-container {
  width: 100%;
  max-width: 900px;

  min-height: 1100px;

  margin: 0 auto;

  padding: 45px 55px;

  box-sizing: border-box;

  background: #fff;

  color: #000;

  font-family:
    "Times New Roman",
    Times,
    serif;

  font-size: 16px;

  border: 1px solid #ccc;
}

.header-logo {
  width: 100%;

  display: flex;

  justify-content: center;

  align-items: center;

  margin-bottom: 20px;
}


.header-logo img {
  max-width: 250px;

  max-height: 100px;

  object-fit: contain;
}

.logo-placeholder {
  width: 185px;

  height: 75px;

  display: flex;

  justify-content: center;

  align-items: center;

  background: #ffd1d1;

  border: 2px solid #333;

  font-weight: bold;

  font-size: 16px;
}

.school-info-center {
  width: 100%;

  text-align: center;

  margin-bottom: 10px;
}


.trust-name {
  font-size: 15px;

  font-weight: bold;

  margin-bottom: 3px;
}


.school-name {
  font-size: 19px;

  font-weight: bold;

  margin: 0 0 4px 0;
}


.school-address {
  font-size: 13px;

  margin-top: 3px;
}

.receipt-title-wrapper {
  width: 100%;

  text-align: center;

  margin-top: 20px;

  margin-bottom: 55px;
}


.receipt-title {
  display: inline-block;

  margin: 0;

  padding-bottom: 5px;

  font-size: 20px;

  font-weight: bold;

  border-bottom: 2px solid #000;
}

.info-grid {
  width: 100%;

  margin-bottom: 35px;
}


.info-row {
  width: 100%;

  display: flex;

  justify-content: space-between;

  align-items: center;

  margin-bottom: 28px;
}


.info-col {
  width: 33.333%;

  flex: 0 0 33.333%;

  font-size: 15px;

  line-height: 22px;

  white-space: nowrap;
}


.label {
  font-weight: bold;

  margin-right: 5px;
}


.value {
  font-weight: normal;
}

.text-left {
  text-align: left;
}


.text-center {
  text-align: center;
}


.text-right {
  text-align: right;
}

.table-wrapper {
  width: 100%;

  display: flex;

  justify-content: center;

  margin-bottom: 28px;
}

.bordered-table {
  border-collapse: collapse;

  text-align: center;

  color: #000;
}


.bordered-table th,
.bordered-table td {
  border: 2px solid #1e3a8a;

  padding: 10px 14px;

  font-size: 15px;

  height: 30px;
}


.bordered-table th {
  font-weight: bold;

  background: #fff;
}

.particulars-table {
  width: 55%;

  min-width: 420px;
}


.particulars-table th:nth-child(1),
.particulars-table td:nth-child(1) {
  width: 20%;
}


.particulars-table th:nth-child(2),
.particulars-table td:nth-child(2) {
  width: 50%;
}


.particulars-table th:nth-child(3),
.particulars-table td:nth-child(3) {
  width: 30%;
}


.particular-name {
  text-align: left;
}

.total-row td {
  border: none !important;

  background: #fff;
}


.total-label-cell {
  text-align: right;

  padding-right: 15px !important;
}


.total-label {
  display: inline-block;

  font-weight: bold;

  padding-bottom: 3px;

  border-bottom: 2px solid #000;
}


.total-amount-cell {
  border: 2px solid #1e3a8a !important;

  font-weight: bold;

  text-align: center;
}

.acknowledgment-text {
  width: 100%;

  text-align: center;

  font-weight: bold;

  font-size: 16px;

  line-height: 25px;

  margin-top: 65px;

  margin-bottom: 28px;
}

.transaction-table {
  width: 65%;

  min-width: 500px;
}


.transaction-table th,
.transaction-table td {
  padding: 10px 12px;
}

.footer-signature {
  width: 100%;

  text-align: center;

  margin-top: 105px;

  font-size: 16px;

  font-weight: bold;
}

.loading-container {
  width: 100%;

  min-height: 500px;

  display: flex;

  flex-direction: column;

  justify-content: center;

  align-items: center;

  text-align: center;
}


.loading-text {
  margin-top: 20px;

  font-size: 16px;
}

@media print {

  @page {
    size: A4 portrait;

    margin: 10mm;
  }


  html,
  body {
    margin: 0 !important;

    padding: 0 !important;

    background: #fff !important;
  }


  .receipt-page {
    padding: 0 !important;

    margin: 0 !important;

    min-height: 0 !important;
  }


  .receipt-container {
    width: 100%;

    max-width: none;

    min-height: 0;

    margin: 0;

    padding: 25px 35px;

    border: none;

    box-sizing: border-box;
  }


  .no-display {
    display: none !important;
  }


  .print-toolbar {
    display: none !important;
  }


  .particulars-table {
    width: 55%;
  }


  .transaction-table {
    width: 65%;
  }


  .footer-signature {
    margin-top: 80px;
  }

}
</style>